import { Badge, Button, Spinner } from 'avo-ui'
import Select from 'components/commons/select'
import IcPoint from 'assets/images/ic-point.svg'
import Table from 'components/commons/table'
import { TABLE_ORDER_DETAIL } from 'configs/order/configOrderDetail'
import { convertStatusText, formatDateMoment, setCurrency } from 'utils/utils'
import { Timeline } from 'components/order/order-detail/Timeline'
import { STATUS_ORDER_NEW } from 'configs/order/configOrder'
import { STATUS } from 'constants/constant'

export const OrderDetail = ({
    data,
    selectedValue,
    onSelectValue,
    onChangeState,
    shippingDetail,
    orderLog,
    isLoading,
}) => {
    return (
        <div className={'px-9 py-6'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'border border-neutral-200 rounded bg-neutral-5'}>
                        <div
                            className={
                                'flex flex-row items-center justify-between px-6 py-3 border-b border-neutral-200'
                            }
                        >
                            <div className={'flex flex-row items-center space-x-9'}>
                                <p className={'text-blue-90 font-bold'}>{data?.invoice_number}</p>
                                <Badge title={convertStatusText(data?.status)} type={data?.status} />
                            </div>
                            <p className={'font-medium text-gray-95'}>
                                {formatDateMoment(data?.created_at, 'DD/MM/YYYY HH:mm')}
                            </p>
                        </div>
                        <div className={'px-6 py-3 flex flex-row items-center justify-between'}>
                            <div className={'flex flex-row items-center space-x-6'}>
                                <img
                                    alt={'image profile'}
                                    src={data?.user?.image_url}
                                    className={'w-12 h-12 rounded-full'}
                                />
                                <div className={'space-y-2'}>
                                    <p className={'font-bold text-base text-black-95'}>{data?.user?.fullname}</p>
                                    <div className={'flex flex-row items-center text-gray-95 gap-4 font-medium'}>
                                        <p>{data?.user?.email}</p>
                                        <p>{data?.user?.phone}</p>
                                    </div>
                                </div>
                            </div>
                            {!(data?.status === STATUS.CANCELLED) && (
                                <div className={'space-y-2'}>
                                    <p className={'text-black-95 font-bold'}>Change Status</p>
                                    <div className={'flex flex-row gap-4'}>
                                        <Select
                                            name={'state'}
                                            className={'w-32'}
                                            placeholder={'Select Status'}
                                            options={STATUS_ORDER_NEW[data?.status]}
                                            value={selectedValue}
                                            onChange={(status) => onSelectValue(status.value)}
                                        />
                                        <Button
                                            title={'APPLY'}
                                            onClick={onChangeState}
                                            disabled={!selectedValue?.label}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={'grid grid-cols-3 gap-8 mt-8'}>
                        <div className={'col-span-2 space-y-12'}>
                            <div className={'border rounded border-neutral-200 p-6 space-y-4'}>
                                <p className={'text-blue-90 font-medium text-base'}>PENGIRIMAN</p>
                                <div className={'grid grid-cols-2 gap-8'}>
                                    <div className={'space-y-4'}>
                                        <p className={'font-medium text-blue-90'}>Billing Address</p>
                                        <div>
                                            <p className={'font-bold text-black-95'}>
                                                {data?.address?.billing?.name ?? '-'}
                                            </p>
                                            <p className={'font-light'}>{data?.address?.billing?.phone ?? '-'}</p>
                                        </div>
                                        <p className={'font-light'}>{data?.address?.billing?.full_address ?? '-'}</p>
                                    </div>
                                    <div className={'space-y-4'}>
                                        <p className={'font-medium text-blue-90'}>Shipping Address</p>
                                        <div>
                                            <p className={'font-bold text-black-95'}>
                                                {data?.address?.shipping?.name ?? '-'}
                                            </p>
                                            <p className={'font-light'}>{data?.address?.shipping?.phone ?? '-'}</p>
                                        </div>
                                        <p className={'font-light'}>{data?.address?.shipping?.full_address ?? '-'}</p>
                                    </div>
                                </div>
                                <div className={'space-y-2'}>
                                    <p className={'font-bold text-black-95'}>Notes</p>
                                    <p className={'font-light'}>{data?.address?.notes ?? '-'}</p>
                                </div>
                            </div>
                            <div>
                                <p className={'text-blue-90 font-medium text-base pl-6'}>PESANAN</p>
                                <Table
                                    className='my-4'
                                    columns={TABLE_ORDER_DETAIL.column}
                                    data={data?.transaction?.products}
                                />
                                <div className={'space-y-4'}>
                                    <div
                                        className={
                                            'flex flex-row items-center justify-between bg-neutral-5 px-6 py-2 text-neutral-80 font-bold'
                                        }
                                    >
                                        <p>SUB TOTAL</p>
                                        <p>{setCurrency(data?.transaction?.subtotal)}</p>
                                    </div>
                                    <div
                                        className={
                                            'flex flex-row items-center justify-between px-6 py-2 text-black-95 font-medium'
                                        }
                                    >
                                        <p>Ongkos Kirim</p>
                                        <p>{setCurrency(data?.transaction?.shipping_total)}</p>
                                    </div>
                                    <div
                                        className={
                                            'flex flex-row items-center justify-between px-6 py-2 text-black-95 font-medium'
                                        }
                                    >
                                        <p>TAX</p>
                                        <p>{setCurrency(data?.transaction?.tax_total)}</p>
                                    </div>
                                    <div
                                        className={
                                            'flex flex-row items-center justify-between px-6 py-2 text-black-95 font-medium'
                                        }
                                    >
                                        <p>Voucher</p>
                                        <p className={'text-red-50'}>- {setCurrency(data?.transaction?.voucher)}</p>
                                    </div>
                                    <div
                                        className={
                                            'flex flex-row items-center justify-between px-6 py-2 text-black-95 font-medium'
                                        }
                                    >
                                        <p>Point</p>
                                        <p className={'text-red-50'}>
                                            - {setCurrency(data?.transaction?.loyalty_point)}
                                        </p>
                                    </div>
                                    <div
                                        className={
                                            'flex flex-row items-center justify-between bg-blue-5 px-6 py-2 text-blue-90 font-bold'
                                        }
                                    >
                                        <p>GRAND TOTAL</p>
                                        <p>{setCurrency(data?.transaction?.grand_total)}</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={
                                    'border rounded border-neutral-200 p-6 flex flex-row items-center justify-between'
                                }
                            >
                                <p className={'text-neutral-90 font-bold'}>Payment Method</p>
                                <div className={'flex flex-row items-center space-x-6'}>
                                    <img
                                        src={data?.transaction?.payment_image}
                                        alt={'Payment Method'}
                                        className={'w-20'}
                                    />
                                    <p>{data?.transaction?.payment_method}</p>
                                </div>
                            </div>
                            <div className={'grid grid-cols-2 gap-6'}>
                                <div className={'border rounded border-neutral-200 p-6 gap-4'}>
                                    <p className={'text-blue-90 font-medium text-base'}>VOUCHER</p>
                                    {data?.transaction?.vouchers.length > 0 &&
                                        data?.transaction?.vouchers.map((item, index) => (
                                            <div className={'flex flex-row items-center space-x-4 py-3'} key={index}>
                                                <img src={item?.thumbnail} alt={'voucher'} className={'w-8 h-8'} />
                                                <div>
                                                    <p className={'font-medium'}>{item.code}</p>
                                                    <p className={'font-thin text-11 text-neutral-40'}>
                                                        {item?.date_expires &&
                                                            formatDateMoment(item.date_expires, 'DD MMM YYYY')}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                                {data?.transaction?.loyalty_point > 0 && (
                                    <div className={'border rounded border-neutral-200 p-6'}>
                                        <p className={'text-blue-90 font-medium text-base'}>POINT</p>
                                        <div className={'flex flex-row items-center space-x-4 py-3'}>
                                            <img src={IcPoint} alt={'IcPoint'} />
                                            <p className={'font-bold text-gray-95'}>
                                                Menggunakan {data?.transaction?.loyalty_point} Point
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={'space-y-10'}>
                            <div className={'border border-neutral-200 rounded'}>
                                <div className={'p-6 border-b border-neutral-200 space-y-4'}>
                                    <p className={'text-center text-blue-90 text-base font-bold'}>Expedition</p>
                                    <div className={'flex flex-row items-center text-gray-95 justify-between'}>
                                        <img
                                            src={shippingDetail?.shipping_image}
                                            alt={'expedition-logo'}
                                            className={'w-16'}
                                        />
                                        <div>
                                            <p className={'font-medium'}>No Resi</p>
                                            <p>{shippingDetail?.awb ?? '-'}</p>
                                        </div>
                                        <div>
                                            <p className={'font-medium'}>{shippingDetail?.shippingMethod}</p>
                                            <p>{shippingDetail?.destination}</p>
                                        </div>
                                    </div>
                                </div>
                                {!!shippingDetail > 0 && (
                                    <div className={'p-6'}>
                                        <Timeline data={shippingDetail?.history} />
                                    </div>
                                )}
                            </div>
                            <div className={'border border-neutral-200 rounded'}>
                                <div className={'p-6 border-b border-neutral-200 space-y-4'}>
                                    <p className={'text-center text-blue-90 text-base font-bold'}>Order History</p>
                                </div>
                                {!!orderLog && (
                                    <div className={'p-6'}>
                                        <Timeline data={orderLog?.logs} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
